<script setup>
import { computed } from 'vue'

const props = defineProps({
  icon: {
    type: [Object, Function],
    required: true
  },
  title: {
    type: String,
    required: true
  },
  subtitle: {
    type: String,
    required: true
  },
  delay: {
    type: Number,
    default: 0
  }
})

const animationStyle = computed(() => ({
  animationDelay: `${props.delay}s`
}))
</script>

<template>
  <div
    class="bg-white rounded-2xl p-6 shadow-lg shadow-slate-200/50 border border-slate-100 animate-float"
    :style="animationStyle"
  >
    <div class="flex items-center gap-4">
      <div class="w-12 h-12 bg-accent-100 rounded-xl flex items-center justify-center">
        <component :is="icon" class="w-6 h-6 text-accent-600" />
      </div>
      <div>
        <p class="font-semibold text-text-primary">{{ title }}</p>
        <p class="text-sm text-text-tertiary">{{ subtitle }}</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
@reference "../../assets/styles/main.css";

.animate-float {
  animation: floatV3 4s ease-in-out infinite;
}

@media (prefers-reduced-motion: reduce) {
  .animate-float {
    animation: none;
  }
}
</style>
